"use strict";
/**
 * Search API Types
 *
 * Types for pattern and user search functionality.
 *
 * Derivation note: All search types remain standalone because search results
 * come from OpenSearch (not DynamoDB). The opensearch.ts service constructs
 * PatternSearchResult by mapping OpenSearch _source fields. There is no DynamoDB
 * record type to derive from.
 *
 * The local PatternSearchResult/UserSearchResult/BlendedSearchResult interfaces
 * in lambda-main/src/services/opensearch.ts mirror these types.
 */
Object.defineProperty(exports, "__esModule", { value: true });
